// Maps backend resource keys to their corresponding translation keys
export const RESOURCE_LABEL_MAP = {
    user: 'users',
    payment_setting: 'payment_setting',
    credential: 'credentials',
    agent: 'agents',
    channel: 'channels',
    knowledge_base: 'knowledge_bases',
    knowledge_entry: 'knowledge_entries',
    contact: 'contacts',
    conversation: 'conversations',
    message: 'messages',
    media: 'media',
    payment: 'payments',
    transaction: 'transactions',
    ticket: 'tickets',
    ticket_comment: 'ticket_comment',
};

// Keep in sync with API/app/models/data_import_model.py IMPORTABLE_RESOURCES.
export const IMPORTABLE_RESOURCE_VALUES = [
    'knowledge_base',
    'knowledge_entry',
    'agent',
];
